<template>
  <div class="wownow-launch" @click="launchClick" v-if="isShow">
    <wx-open-launch-app v-if="appid" id="launch-btn" :appid="appid" :extinfo="extinfoProps">
      <script type="text/wxtag-template">
        <style>
          .wechat-btn-to-wownowasdfasdfads {
            width: 100%;
            border: 0 none;
            background-color: transparent;
            border-color: transparent;
            outline: none;
            {{ btnStyle }}
          }
          .wechat-btn-to-wownowasdfasdfads:active, .wechat-btn-to-wownowasdfasdfads:hover, .wechat-btn-to-wownowasdfasdfads:link, .wechat-btn-to-wownowasdfasdfads:visited {
            border: 0 none;
            box-shadow: none;
            outline: none;
            border-color: transparent;
          }
        </style>
        <button class="wechat-btn-to-wownowasdfasdfads"></button>
      </script>
    </wx-open-launch-app>
    <!-- <button class="wechat-btn-to-wownowasdfasdfads"></button> -->
    <!-- <button class="wechat-btn-to-wownow" style="width: 7.89rem;height: 1.2rem;background: #ff5b00;border-radius: 0.13rem;position: relative;margin: 0 auto;font-size: 0.45rem;font-family: PingFang SC;font-weight: 400;color: #fff;border: 0 none;transition: all 0.1s;display: block;"> {{ registerButton }} </button> -->
  </div>
</template>
<script>
export default {
  props: {
    appid: {
      type: String,
      default: () => ''
    },
    clientWidth: {
      type: [Number, String],
      default: () => 0
    },
    clientHeight: {
      type: [Number, String],
      default: () => 0
    },
    extinfoProps: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      wechatBtn: undefined,
      isShow: this.appid,
      style: {
        height: 0,
        width: 0
      }
    };
  },
  computed: {
    btnStyle() {
      return Object.keys(this.style).map(e => `${e}: ${this.style[e]}px`).join(';');
    }
  },
  watch: {
    clientWidth(val) {
      this.$nextTick(() => {
        this.style.width = val;
      })
    },
    clientHeight(val) {
      this.$nextTick(() => {
        this.style.height = val;
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      new Promise((resolve, reject) => {
        this.wechatBtn = document.getElementById('launch-btn');
        this.wechatBtn.addEventListener('launch', e => resolve(e));
        this.wechatBtn.addEventListener('error', e => reject(e));
      }).then(res => this.$emit('launch-success')).catch(e => {
        console.log('launch-error: ', e);
        this.$emit('launch-error', e);
      }).finally(() => {
        this.timeout(() => {
          this?.wechatBtn?.remove();
          this.isShow =false;
        }, 10);
      });
    });
  },
  methods: {
    launchClick() {
      this.$emit('click');
    },
    timeout(fn, time = 0) {
      const __timeout = setTimeout(() => {
        clearTimeout(__timeout);
        typeof fn === 'function' && fn();
      }, time);
    }
  }
}
</script>

<style lang="stylus" scoped>
  .wownow-launch {
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index 1000;
  }
</style>

<style lang="stylus">
  .wechat-btn-to-wownowasdfasdfads {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%
    border: 0 none;
    background-color: transparent;
    border-color: transparent;
    z-index: 99999
  }
  .wechat-btn-to-wownowasdfasdfads:active, .wechat-btn-to-wownowasdfasdfads:hover, .wechat-btn-to-wownowasdfasdfads:link, .wechat-btn-to-wownowasdfasdfads:visited {
    border: 0 none;
    box-shadow: none;
    border-color: transparent;
  }
</style>

